import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../config/firebase';
import { useCompany } from '../context/CompanyContext';

const LoginPage = ({ setNotification }) => {
    const { logoUrl, name: companyName } = useCompany(); 
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (error) {
            console.error("Login error:", error);
            setNotification({ message: 'Credenciales incorrectas o error de conexión.', type: 'error' });
            setLoading(false);
        }
    };

    const handlePasswordReset = async () => {
        if (!email) {
            setNotification({ message: 'Por favor, ingresa tu correo en el campo "Correo Electrónico".', type: 'error' });
            return;
        }
        setLoading(true);
        try {
            await sendPasswordResetEmail(auth, email);
            setNotification({ message: `Se ha enviado un correo de reseteo a ${email}.`, type: 'success' });
        } catch (error) {
            console.error("Error sending password reset email:", error);
            setNotification({ message: `Error al enviar el correo: ${error.message}`, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex flex-col items-center justify-center p-4 transition-colors duration-300">
            <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg w-full max-w-md mb-8 border border-transparent dark:border-gray-700 transition-colors">
                
                {/* LOGO DINÁMICO */}
                <div className="flex justify-center mb-6">
                    {logoUrl ? (
                        <img 
                            src={logoUrl} 
                            alt={companyName || "Logo Empresa"} 
                            className="h-24 w-auto object-contain bg-white rounded p-1"
                        />
                    ) : (
                        <h2 className="text-2xl font-bold text-blue-900 dark:text-blue-400 text-center">
                            {companyName || 'Bienvenido'}
                        </h2>
                    )}
                </div>

                <h1 className="text-xl font-semibold text-center text-gray-500 dark:text-gray-400 mb-6">Iniciar Sesión</h1>
                
                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label className="block text-gray-600 dark:text-gray-300 mb-2 text-sm font-medium" htmlFor="email">Correo Electrónico</label>
                        <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-600 dark:text-gray-300 mb-2 text-sm font-medium" htmlFor="password">Contraseña</label>
                        <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required />
                    </div>
                    
                    <div className="text-right mb-6">
                        <button
                            type="button"
                            onClick={handlePasswordReset}
                            disabled={loading}
                            className="text-sm text-blue-600 dark:text-blue-400 hover:underline disabled:text-gray-400 dark:disabled:text-gray-500"
                        >
                            ¿Olvidaste tu contraseña?
                        </button>
                    </div>

                    <button type="submit" disabled={loading} className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-300 disabled:bg-blue-300 disabled:dark:bg-blue-800 font-bold">
                        {loading ? 'Procesando...' : 'Ingresar'}
                    </button>
                </form>
            </div>

            {/* FOOTER DEL LOGIN - DERECHOS RESERVADOS */}
            <div className="text-center text-xs text-gray-400 dark:text-gray-500">
                <p className="mb-1">© {new Date().getFullYear()} <strong>BantCore System</strong>. Todos los derechos reservados.</p>
                <p>Desarrollado y mantenido por <span className="font-semibold text-gray-500 dark:text-gray-400">Bant Ingeniería y Asesoría SpA</span></p>
            </div>
        </div>
    );
};

export default LoginPage;